import { CacheModule } from "@/services/cacheModule";
import { VIP_VIDEO_CACHE } from "@/utils/nativeStorage/local_keys";

class VideoPathCache extends CacheModule {
  constructor() {
    super(VIP_VIDEO_CACHE, null);
  }
}
export default new VideoPathCache();
